import { IncomeLookup } from './case-management/case-income-types';
import { RowInputType } from './row-input-type';

//'tips' for tooltips have been moved to libs\common\shared\src\lib\labels\aish\income.labels.ts
//because content requires transformation (4 variations of content for obo)
export const AishIncomeTypes: { [name: string]: IncomeLookup } = {
  employmentIncome: {
    order: 1,
    displayValue: 'Employment income',
    documentTypes: [
      'Pay stubs',
      'Written document from employer (must include name of employer, name of employee, pay period, date of pay, gross income/deductions)',
    ],
    categoryTitleOverride: 'Proof of employment income',
    // tips: 'Money you receive from: salary, wages, bonuses',
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  selfEmploymentIncome: {
    order: 2,
    displayValue: 'Self-employment',
    documentTypes: [
      'Most recent income tax return with notice of assessment',
      'Statement of net self-employment income',
      'Audited financial statement',
    ],
    categoryTitleOverride: 'Proof of self-employment',
    // tips: `Earned from a business you operate as a sole proprietor or with someone else as a partner
    // including earnings from:
    // <ul>
    //   <li>a business</li>
    //   <li>sales commission</li>
    //   <li>farming</li>
    //   <li>fishing activities</li>
    // </ul>`,
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  employmentInsurance: {
    order: 3,
    displayValue: 'Employment Insurance (EI)',
    documentTypes: ['EI payment stubs', 'Statement from EI'],
    categoryTitleOverride: 'Proof of Employment Insurance (EI)',
    // tips: `Federal government benefits for:
    // <ul>
    //   <li>people who have lost a job through no fault of their own – (for example, due to work shortage or seasonal work)</li>
    //   <li>people able and available to work, but can’t find a job</li>
    //   <li>parents on maternity or paternity leave</li>
    // </ul>`,
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  canadaDisabilityBenefit: {
    order: 4,
    displayValue: 'Canada Disability Benefit (CDB)',
    documentTypes: ['Canada Disability Benefit (CDB)'],
    categoryTitleOverride: 'Proof of Canada Disability Benefit (CDB)',
    // tips: `The Canada Disability Benefit (CDB) is a federal disability benefit program that provides up to $200 per month to eligible Canadians with disabilities aged 18 to 64.
    // To apply for the CDB, you need to file a tax return and be eligible for the Disability Tax Credit`,
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  canadaPensionPlan: {
    order: 5,
    displayValue: 'Canada Pension Plan (CPP)',
    documentTypes: ['Statement from source', 'Cheque stub', 'Latest income tax assessment', 'Direct deposit statement'],
    categoryTitleOverride: 'Proof of Canada Pension Plan (CPP)',
    // tips: `Federal government benefits including
    // <ul>
    //   <li>retirement pension (CPP)</li>
    //   <li>disability benefit (CPP-D)</li>
    //   <li>survivor’s pension</li>
    // </ul>`,
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  oldAgeSecurity: {
    order: 6,
    displayValue: 'Old Age Security (OAS)',
    documentTypes: ['Direct deposit statement', 'Cheque stub', 'Written statement from WCB'],
    categoryTitleOverride: 'Proof of Old Age Security (OAS)',
    // tips: `Federal government benefits for seniors aged 65 and older and/or their spouses/partners, aged 60 to 64:
    // <ul>
    //   <li>Old Age Security pension (OAS)</li>
    //   <li>Allowance for the survivor</li>
    //   <li>Guaranteed Income Supplement (GIS)</li>
    //   <li>Allowance for a GIS recipient’s spouse/partner</li>
    // </ul>`,
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  pensionIncome: {
    order: 7,
    displayValue: 'Pension income from previous employment',
    documentTypes: ['Pension income from previous employment'],
    categoryTitleOverride: 'Proof of pension income from previous employment',
    // tips: `Income provided by a pension program like:
    // <ul>
    //   <li>military pension</li>
    //   <li>provincial pension plans</li>
    //   <li>retirement compensation arrangements</li>
    // </ul>`,
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  disabilityInsurance: {
    order: 8,
    displayValue: 'Disability/Wage loss insurance',
    documentTypes: ['Disability/Wage loss insurance'],
    categoryTitleOverride: 'Proof of disability/wage loss insurance',
    // tips: 'Payments from an insurance company when an employee is no longer able to earn a living',
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  trustAccountIncome: {
    order: 9,
    displayValue: 'Income from trust accounts',
    documentTypes: ['Income from trust accounts'],
    categoryTitleOverride: 'Proof of income from trust accounts',
    // tips: 'Include principal and interest payments',
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  investmentIncome: {
    order: 10,
    displayValue: 'Income from investments',
    documentTypes: [
      'Statement from payer, broker, or bank',
      'Cheque stubs',
      'Direct deposit/bank statement',
      'Latest income tax assessment',
    ],
    categoryTitleOverride: 'Proof of income from investments',
    // tips: `<ul>
    // <li>Interest payments</li>
    // <li>Dividends</li>
    // <li>Capital gains from selling a security or other assets</li>
    // <li>Any other profit from any investment</li>
    // </ul>`,
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  rentalIncome: {
    order: 11,
    displayValue: 'Income from a rental property',
    documentTypes: [
      'Income tax return with notice of assessment (most recent)',
      'Rent book/receipts',
      'Lease or rental agreement',
      'Written statement/declaration from boarder',
    ],
    categoryTitleOverride: 'Proof of income from a rental property',
    // tips: 'Rental Income: Income from a property or room you rent to someone else',
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  lifeInsuranceIncome: {
    order: 12,
    displayValue: 'Life insurance income',
    documentTypes: ['Life insurance income'],
    categoryTitleOverride: 'Proof of life insurance income',
    // tips: 'Income paid to you as a beneficiary of a life insurance policy',
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  guaranteedSupplement: {
    order: 13,
    displayValue: 'Guaranteed Income Supplement (GIS)',
    documentTypes: ['Guaranteed Income Supplement (GIS)'],
    categoryTitleOverride: `Proof of Guaranteed Income Supplement (GIS)`,
    // tips: '',
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  spousalSupport: {
    order: 14,
    displayValue: 'Spousal support/alimony',
    documentTypes: ['Decree Nisi', 'Separation agreement', 'Court order', 'Confirmation from Child Support Service'],
    categoryTitleOverride: `Proof of spousal support/alimony`,
    // tips: 'Money that one spouse/partner may have to pay the other spouse/partner due to a separation or divorce',
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  wcbIncome: {
    order: 15,
    displayValue: "Workers' Compensation Benefits (WCB)",
    documentTypes: [
      'Income tax return with notice of Assessment (most recent)',
      'WCB payment stub',
      'Written statement from WCB',
    ],
    categoryTitleOverride: `Proof of Workers' Compensation Benefits (WCB)`,
    // tips: 'Payment for workplace injuries or illnesses',
    needSupportDocument: true,
    inputType: RowInputType.DollarValue,
  },
  otherSourcesOfIncome: {
    code: 'otherSourcesOfIncome',
    order: 16,
    displayValue: 'Other sources of income',
    documentTypes: ['Other sources of income'],
    needSupportDocument: true,
    helpText: 'e.g. Money in trust for children, gifts',
    isSpecial: true,
    inputType: RowInputType.DollarValue,
  },
  specialPayment: {
    code: 'specialPayment',
    order: 17,
    displayValue: 'Special payment',
    documentTypes: ['Special payment'],
    needSupportDocument: true,
    isSpecial: true,
    inputType: null,
  },
};

//this is used to differentiate properties in income.ts entity that are valid income types vs normal properties/fields.
//converts keys to an array list so we can filter using 'includes'
export const AishValidIncomeTypes = Object.keys(AishIncomeTypes) as (keyof typeof AishIncomeTypes)[];
